import { ModalFooter, ModalFooterButton } from '@/components/Modal'

import { useController } from '../../hooks/useController'

import { useOnSubmit } from './hooks/useOnSubmit'
import { useTexts } from './hooks/useTexts'

export function Footer() {
  const { status, close } = useController()

  const texts = useTexts()
  const submit = useOnSubmit()

  const submitting = status === 'submitting'

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton
          variant="contained"
          onClick={submit}
          loading={submitting}
          disabled={submitting}
          maxWidth="50%"
          testid="disable-user-modal-confirm-button"
          data-trackid="disable-user-modal-confirm-button"
        >
          {texts.disable}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton
          variant="text"
          onClick={close}
          disabled={submitting}
          testid="disable-user-modal-cancel-button"
          data-trackid="disable-user-modal-cancel-button"
        >
          {texts.cancel}
        </ModalFooterButton>
      }
    />
  )
}
